<template lang="html">
  <v-container style="margin-top: 2em;">
<h2> Actualités </h2> <br>

<div v-html="shayofaePressReleaseHtml"></div>
</br></br>
<div v-html="shayofaeTutorialPitchHtml"></div>

<div style="font-family: Arial, sans-serif; font-size: 14px; letter-spacing: normal; line-height: 24px; text-align: left; color: #55575d;">
		<p style="margin: 10px 0;"><span style="font-family: Verdana,Helvetica,Arial,sans-serif;">Nouveaut&eacute; 5/09/2025</span></p>
<br/>
Avec son assistant vocal et sa nouvelle IA de recommandation variétale, ShaYoFae propose aux agriculteurs les variétés de betterave les mieux adaptées à leurs sols, leurs pratiques et leur climat local.<br/><br/>
👉 Des données historisées, issues de l’intelligence collective.<br/>
👉 Des recommandations personnalisées, fiables et durables.<br/>
👉 Un accompagnement et des arguments pédagogiques pour enrichir les connaissances.<br/>
👉 Un gain de temps, de productivité… et une réduction des intrants.<br/><br/><br/>
<p style="margin: 10px 0;">
<span style="font-family: Verdana,Helvetica,Arial,sans-serif;font-size: 16px;"><strong>ShaYoFae, c’est l’alliance de l’AgTech et de la filière betterave pour relever les défis de demain.</strong></span></p>
 <br/><br/><br/><br/><br/><br/></div>

<div style="font-family: Arial, sans-serif; font-size: 14px; letter-spacing: normal; line-height: 24px; text-align: left; color: #55575d;">
		<p style="margin: 10px 0;"><span style="font-family: Verdana,Helvetica,Arial,sans-serif;">Communiqu&eacute; de presse 25/11/2022</span></p>
		<p style="margin: 10px 0;">
			<span style="font-family: Verdana,Helvetica,Arial,sans-serif;font-size: 16px;"><strong>Partenariat Technologique BETADIGITIS - AMD AGRO SERVICE&nbsp;</strong></span></p>
		</div>

		<div style="font-family: Arial, sans-serif; font-size: 14px; letter-spacing: normal; line-height: 24px; text-align: left; color: #55575d;"><br>
		<p style="text-align: center;">
				<h1 class="western" align="center"><font face="Cambria, serif"><b><span style="background: transparent">Les
				start-ups numériques de l’agriculture BETADIGITIS - ShaYoFae
				(France) et AMD AGRO SERVICES – </span></b></font><font color="#0563c1"><u><a href="http://www.pamdagro.ci/"><font face="Cambria, serif"><b><span style="background: transparent">www.pamdagro.ci</span></b></font></a></u></font><font face="Cambria, serif"><b><span style="background: transparent">
				(Côte d’Ivoire) annoncent un partenariat technologique dans le
				cadre de l’expansion de leurs activités.</span></b></font></h1>
				<p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
				<br/></p>
				<h2 class="western" align="center"><b><span style="background: transparent">Ce
				partenariat vise à améliorer la productivité des exploitations
				agricoles en Afrique de l’ouest à commencer par la Côte d’Ivoire.</span></b></h2>
				<p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
				<br/></p>
	 </p>
	 <p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
	 <span style="background: transparent">ABIDJAN, le 21 Novembre 2022</span>
	 - BETADIGITIS et AMD AGRO SERVICES engagent un partenariat pour aider
	 les producteurs agricoles des régions de l’Afrique de l’ouest à
	 mieux maîtriser les techniques et pratiques culturales par le
	 déploiement d’une solution numérique de partage et de comparaison
	 des pratiques agricoles et de diffusion de conseils techniques sous
	 forme de vidéos, podcasts et documents web dans les pays d’Afrique
	 de l’Ouest; et plus spécifiquement en démarrant par la Côte
	 d’Ivoire.</p>
	 <p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
	 <br/></p>
	 <p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
	 La solution numérique proposée par BETADIGITIS, <b>ShaYoFae</b>
	 («&nbsp;<i><b>Share Your Farming Experience</b></i>&nbsp;» en
	 anglais ou «&nbsp;<i><b>Partage Ta Plantation</b></i>&nbsp;» en
	 français courant), est une application mobile qui permet aux
	 exploitants agricoles de partager et de comparer les techniques
	 agricoles qu’ils utilisent dans un but d’apprentissage et
	 d’enrichissement des savoirs et savoir-faire au bénéfice de leurs
	 communautés.</p>
	 <p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
	 L’application est enrichie de conseils techniques, en lien direct
	 avec les pratiques agricoles, qui seront diffusés sous forme de
	 podcast, de courtes vidéos et d’illustrations.</p>
	 <p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
	 <br/></p>

	 <p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
	 AMD Agro Services réalise progressivement grâce à son
	 savoir-faire, des conseils techniques pour le suivi des itinéraires
	 techniques des principales cultures agricoles de la sous-région
	 ouest africaine, sous différents formats numériques (vidéos,
	 podcasts, documents web, etc.) traduites en langues locales qui
	 seront diffusés par l’application ShaYoFae.</p>
	 <p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
	 <br/></p>
	 <p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
	 <span style="background: transparent">L’objectif visé par ce
	 partenariat est de valoriser les expertises des deux Start-ups en les
	 mettant au service de l’agriculture et des exploitants agricoles en
	 Côte d’Ivoire, et partant en Afrique de l’ouest. La diffusion,
	 la mutualisation et la capitalisation des connaissances agricoles est
	 un atout et une nécessité pour le monde de demain. </span>
	 </p>
	 <p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
	 <br/></p>

	 <p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
	 <span style="background: transparent">Ce partenariat vient répondre
	 à la problématique des services ou conseils agronomiques de
	 précisions à moindre coûts, accessibles et répondant aux besoins
	 des exploitants agricoles en vue de l’amélioration des pratiques
	 culturales et des rendements de production.</span></p>
	 <p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
	 <span style="background: transparent">En associant leurs compétences
	 respectives en agriculture, en agronomie, en technologies numériques
	 innovantes et en créations de contenus multimédias dans une
	 solution numérique mobile performante, les deux start-ups s’engagent
	 dans l’accompagnement de l’agriculture de demain.</span></p>
	 <p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
	 <br/></p>

	 <p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
	 <u><b><span style="background: transparent">A propos d’AMD AGRO
	 SERVICES&nbsp;:</span></b></u></p>
	 <p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
	 Bureau d’études spécialisé dans le conseil, les études et les
	 projets, l’appui et l’assistance aux organisations et entreprises
	 des secteurs de l’agriculture et de l’agroalimentaire en Côte
	 d’Ivoire. Sa vision est d’offrir à ces cibles des services et
	 des solutions numériques innovantes permettant de faciliter la
	 réalisation de leurs objectifs et d’améliorer durablement leur
	 rentabilité.
	 </p>
	 <p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
	 Les activités ont démarré en 2016 par la création et la mise en
	 ligne de la plateforme internet <font color="#0563c1"><u><a href="http://www.pamdagro.ci/">www.pamdagro.ci</a></u></font>
	 dont la mission principale est de rapprocher sur un même espace tous
	 les intervenants des secteurs de l’agriculture et de
	 l’agroalimentaire.
	 </p>
	 <p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
	 Le bureau d’études a pour clients des institutions telles que la
	 Coopération Allemande (GIZ), la Chambre de Commerce et d’Industrie
	 de Côte d’Ivoire (CCI – CI)&nbsp;; des entreprises privées dont
	 trois (03) entreprises agroalimentaires et plus d’une trentaine de
	 sociétés coopératives agricoles réparties dans différentes
	 filières agricoles en Côte d’Ivoire.
	 </p>
	 <p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
	 Son siège est à Cocody II Plateaux Angré 7<sup>e</sup> tranche,
	 Abidjan, Côte d’ivoire.</p>
	 <p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
	 <font color="#0563c1"><u><a href="mailto:connect@pamdagro.ci">connect@pamdagro.ci</a></u></font>
	 </p>
	 <p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
	 <br/></p>
	 <p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
	 <u><b><span style="background: transparent">A propos de BETADIGITIS&nbsp;:</span></b></u></p>
	 <p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
	 Société de services et de solutions numériques qui intervient dans
	 le secteur des services aux acteurs du monde agricole à travers le
	 monde. Elle a développé et mis en ligne une solution numérique de
	 partage et de comparaison d’expériences agricoles entre
	 exploitants agricoles dénommée ShaYoFae. La solution est une
	 application mobile qui aide les exploitants agricoles à enrichir
	 savoirs et savoir-faire par le partage et la comparaison de leurs
	 pratiques agricoles. L’application ShaYoFae a été</p>
<p align="justify" style="line-height: 100%; margin-bottom: 0cm">téléchargée
plus de 100 000 fois dans le Monde et compte quelques milliers
d’utilisateurs réguliers.</p>
	 <p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
	 BETADIGITIS est basée à Chessy en France</p>
	 <p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
	 <font color="#0563c1"><u><a href="mailto:contact@betadigitis.com">contact@betadigitis.com</a></u></font>
	 </p>
	 <p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
	 <br/></p>

	 <h3 class="western" align="justify"><a name="_GoBack"></a><font face="Liberation Serif, serif"><span lang="en-US"><b><span style="background: transparent">###
AMD AGRO SERVICES  -  </span></b></span></font><font color="#0563c1"><u><a href="mailto:connect@pamdagro.ci"><font face="Liberation Serif, serif"><span lang="en-US"><b><span style="background: transparent">connect@pamdagro.ci</span></b></span></font></a></u></font><font face="Liberation Serif, serif"><span lang="en-US"><b><span style="background: transparent">
 - (+225) 07 47 83 80 50 . </span></b></span></font>
</h3>
<br/>
<p class="western" align="justify" style="line-height: 100%; margin-bottom: 0cm">
<span lang="en-US"><b><span style="background: transparent">Pour
Hervé Escriou CEO de la Start-up BETADIGITIS : “</span></b></span><span lang="en-US"><span style="font-weight: normal"><span style="background: transparent">Ce
partenariat est une nouvelle avancée dans l’esprit collaboratif
qui doit encourager et amplifier l’évolution de l’agriculture.
Partager et comparer ses pratiques agricoles pour apprendre des
autres agriculteurs et en plus accèder à des supports techniques en
relation avec les opérations partagées, en podcats ou en courtes
vidéos est un super projet. D’autant que l’adaptation aux
langues locales permettra une utilisation encore plus large en Côte
d’Ivoire et dans les autres pays d’Afrique de l’Ouest. Ce
partenariat est une parfaite complémentarité technique et un
excellent partage d’état d’esprit.</span></span></span><span lang="en-US"><b><span style="background: transparent">”
</span></b></span></p>
<br/>

<p align="justify" style="line-height: 100%; margin-bottom: 0cm"><font color="#1f3763"><b>Pour
Steve DJE Directeur de la Start-up AMD AGRO SERVICES : “</b></font><font color="#1f3763">Ce
partenariat vient compléter notre offre de services numériques aux
acteurs en amont et en aval des principales filières agricoles
ivoiriennes. En plus des multiples services offerts par notre
plateforme web </font><font color="#0563c1"><u><a href="http://www.pamdagro.ci/">www.pamdagro.ci</a></u></font><font color="#1f3763">
, l’application mobile ShaYoFae répond à une de nos
préoccupations qui était de trouver une application numérique
capable d’offrir une assistance et des conseils agronomiques de
précisions à des coûts très bas répondant aux besoins
d’assistance des exploitants agricoles en Côte d’Ivoire et en
Afrique de l’ouest. </font><font color="#1f3763"><b>”</b></font></p>


 <br/><br/><br/><br/><br/><br/></div>



<div style="font-family: Arial, sans-serif; font-size: 14px; letter-spacing: normal; line-height: 24px; text-align: left; color: #55575d;">
		<p style="margin: 10px 0;"><span style="font-family: Verdana,Helvetica,Arial,sans-serif;">Communiqu&eacute; de presse 08/02/2020</span></p>
		<p style="margin: 10px 0;">
			<span style="font-family: Verdana,Helvetica,Arial,sans-serif;font-size: 16px;"><strong>Agtech: il crée le "Linkedin" des agriculteurs&nbsp;</strong></span></p>
		</div>


<div style="font-family: Arial, sans-serif; font-size: 14px; letter-spacing: normal; line-height: 24px; text-align: left; color: #55575d;"><br>
<p style="text-align: center;">
	<span style="font-family: arial,helvetica,sans-serif;">
		<span style="font-size: 16px;"><strong>ShaYoFae, l'application&nbsp;de partage et de comparaison des pratiques agricoles d&eacute;di&eacute;e aux agriculteurs du monde entier</strong></span></span></p>
<p style="color: #55575d; font-family: Arial, sans-serif; font-size: 14px; letter-spacing: normal;">&nbsp;</p>
<p style="text-align: justify;"><span style="font-family: arial,helvetica,sans-serif;">L'agriculture s'est extr&ecirc;mement transform&eacute;e depuis des d&eacute;cennies et sur l'int&eacute;gralit&eacute; du globe dans l'ensemble de ses aspects (&eacute;conomiques, sociaux, territoriaux) et elle doit de plus r&eacute;pondre aux nouveaux enjeux environnementaux<strong>. Pour aider les agriculteurs du monde entier &agrave; relever ces d&eacute;fis et &agrave; r&eacute;pondre &agrave; ces nouveaux challenges, un ing&eacute;nieur agronome fran&ccedil;ais a d&eacute;cid&eacute; de d&eacute;velopper
	<span style="color: #008000;">
	<u>un r&eacute;seau social afin que les acteurs agricoles &eacute;changent et apprennent de leurs voisins directs, comme des plus &eacute;loign&eacute;s</u>
</span>...</strong></span></p>

<p style="margin: 10px 0;"><span style="font-family: Verdana,Helvetica,Arial,sans-serif;"></span>&nbsp;</p>
<p style="text-align: justify;"><span style="font-family: arial,helvetica,sans-serif;"><strong>
	<u>Pourquoi ShaYoFae, et pourquoi en avoir fait un r&eacute;seau social&nbsp;?</u></strong></span></p>
<p style="text-align: justify;"><span style="font-family: arial,helvetica,sans-serif;">Le nom de l'application : <strong>ShaYoFae</strong>, est la compression du slogan&nbsp;de l'application qui porte les valeurs et le sens du projet : SHAre YOur FArming Experience.</span></p>
<p style="text-align: justify;"><span style="font-family: arial,helvetica,sans-serif;">A l'origine&nbsp;de l'application, un constat universel connu de tous : les "paysans"&nbsp;sont ceux qui souffrent le plus des nombreuses &eacute;volutions de leur secteur qui leur demandent d'&ecirc;tre toujours plus flexibles, plus technologiques, plus exigeants mais pour le plus grand nombre, sans avoir les bonnes solutions, avec moins de moyens et de temps.</span></p>
<p style="text-align: justify;"><span style="font-family: arial,helvetica,sans-serif;">Herv&eacute; Escriou a&nbsp;donc l'id&eacute;e en 2018 de m&ecirc;ler ses diff&eacute;rentes passions (l'agriculture et le d&eacute;veloppement informatique), afin d'imaginer&nbsp;une application qui permettrait &agrave; ces derniers de s'entraider en &eacute;changeant directement conseils, bons plans, et plus simplement de rompre l'isolement et la routine du "chacun sur son exploitation" et cela quel qu&rsquo;en soit la taille et le lieu g&eacute;ographique dans le monde.</span></p>
<p style="text-align: justify;">
	<span style="color: #55575d; font-family: arial,helvetica,sans-serif;"><u><strong>Communiquer et s'affranchir de l'isolement :&nbsp;</strong></u></span></p>

<blockquote style="color: #55575d; font-family: Arial, sans-serif; font-size: 14px; letter-spacing: normal;margin-left: 40px; margin-right: 50px;">
<p style="text-align: justify;"><span style="font-family: arial,helvetica,sans-serif;">&laquo;&nbsp;Les communaut&eacute;s d'agriculteurs ainsi construites, permettent de&nbsp;tisser des liens d'apprentissage et d'intelligence collective. C'est aussi&nbsp;un moyen de se lib&eacute;rer de l'isolement dans ses prises de d&eacute;cisions par exemple.&nbsp;&raquo; explique Herv&eacute; Escriou</span></p>
</blockquote>
<p style="text-align: justify;"><span style="font-family: arial,helvetica,sans-serif;"><strong>
	<u>D&eacute;j&agrave; plus de 60 000 t&eacute;l&eacute;chargements dans le monde entier en moins de 6 mois</u>
</strong></span></p>
<p style="text-align: justify;"><span style="font-family: arial,helvetica,sans-serif;">Les utilisateurs sont en <strong>Am&eacute;rique du sud, en Europe, en Afrique</strong>,...</span></p>
<p style="text-align: justify;"><span style="font-family: arial,helvetica,sans-serif;"><strong>
	<u>Comment cela fonctionne</u></strong></span></p>

<blockquote style="color: #55575d; font-family: Arial, sans-serif; font-size: 14px; letter-spacing: normal;margin-left: 40px; margin-right: 50px;">
<p style="text-align: justify;"><span style="font-family: arial,helvetica,sans-serif;"><span style="color: #55575d;"><span style="font-size: small;">&laquo;&nbsp;Avec mon Smartphone, d&egrave;s que je suis au&nbsp;champ, je partage en temps r&eacute;el mes actions&nbsp;: semis, binage, d&eacute;sherbage, observation de la croissance, des maladies et en retour je peux voir les actions des autres agriculteurs et me comparer. Cela me permet de conforter&nbsp;mes d&eacute;cisions ou de modifier certaines de mes habitudes. Je peux faire &eacute;voluer mes&nbsp;techniques plus rapidement en tenant compte des exp&eacute;rimentations des autres agriculteurs&nbsp;et pas uniquement des miennes &raquo; JAD</span></span></span></p>
</blockquote>

<p style="text-align: justify;">&nbsp;</p>
<blockquote style="color: #55575d; font-family: Arial, sans-serif; font-size: 14px; letter-spacing: normal;margin-left: 40px; margin-right: 50px;">
<p style="text-align: justify;"><span style="font-family: arial,helvetica,sans-serif;">&laquo;&nbsp;En proposant d'&eacute;changer des informations techniques entre agriculteurs, c'est tout le savoir et les savoirs faire qui rayonnent librement au b&eacute;n&eacute;fice des productions agricoles et des populations. ShaYoFae est l'application qui permet de faire &eacute;voluer l'agriculture sur tous les continents gr&acirc;ce &agrave; l'exp&eacute;rience partag&eacute;e&nbsp;des agriculteurs.&nbsp;&raquo; commente Herv&eacute; Escriou</span></p>
</blockquote>
<p style="text-align: justify;"><span style="font-family: arial,helvetica,sans-serif;"><strong><u>Une ambition folle&nbsp;: devenir le cha&icirc;non manquant entre un Linkedin et "un tour&nbsp;<span style="color: #55575d;"><span style="font-size: small;">de plaine&nbsp;&raquo; mondial o&ugrave; chaque agriculteur&nbsp;peut tirer des enseignements du travail courant de ses coll&egrave;gues.</span></span></u></strong></span></p>
<p style="text-align: justify;"><span style="font-family: arial,helvetica,sans-serif;"><u><span style="color: #55575d;"><span style="font-size: small;"><strong style="color: #55575d; font-family: arial, helvetica, sans-serif; font-size: small; letter-spacing: normal;">Tout le monde est concern&eacute; par l'alimentation, la qualit&eacute; des aliments,&nbsp;la durabilit&eacute; des modes de productions agricoles et&nbsp;l'impact soci&eacute;tal et </strong>
	<span style="color: #55575d; font-family: arial, helvetica, sans-serif; font-size: small;"><strong>environnemental</strong></span>
	<strong style="color: #55575d; font-family: arial, helvetica, sans-serif; font-size: small; letter-spacing: normal;">&nbsp;de l'agriculture.
		<br>Tout le monde a int&eacute;r&ecirc;t &agrave; soutenir positivement les agriculteurs dans leurs d&eacute;marches de changement et d'adaptation, dans le monde entier.&nbsp;</strong></span></span></u></span></p>

<blockquote style="margin-left: 40px; margin-right: 50px;">
<p style="text-align: justify;"><span style="font-family: arial,helvetica,sans-serif;">
	<span style="color: #55575d;"><span >&laquo; </span></span>
	<span style="">
	<span ><strong style=" font-family: arial, helvetica, sans-serif; font-size: small; letter-spacing: normal;">Et ce ne sont </strong>
	<strong style="color: #55575d; font-family: arial, helvetica, sans-serif; font-size: small; letter-spacing: normal;">pas </strong>
	<strong style="color: #55575d; font-family: arial, helvetica, sans-serif; font-size: small; letter-spacing: normal;">uniquement</strong>
	<strong style="color: #55575d; font-family: arial, helvetica, sans-serif; font-size: small; letter-spacing: normal;"> les agriculteurs </strong>
	qui ont	int&eacute;r&ecirc;t et qui b&eacute;n&eacute;ficieront de la g&eacute;n&eacute;ralisation de
	<strong style="color: #55575d; font-family: arial, helvetica, sans-serif; font-size: small; letter-spacing: normal;">l'utilisation de ShaYoFae. Tout les </strong>
	<span style="color: #55575d; font-family: arial, helvetica, sans-serif; font-size: small;"><strong>consommateurs</strong></span>
	<strong style="color: #55575d; font-family: arial, helvetica, sans-serif; font-size: small; letter-spacing: normal;"> souhaitent que les agriculteurs produisent de la qualit&eacute; en respectant l'environnement</strong></span></span>
	<span style="color: #55575d; font-family: arial, helvetica, sans-serif;">
		<span style="font-size: 14px;"> ! &raquo; assure&nbsp;Herv&eacute; Escriou</span></span></span></p>
</blockquote>
<p style="text-align: justify;"><span style="font-family: arial,helvetica,sans-serif;">C'est d'ailleurs nourri de cette ambition, que le fondateur lance en amont du salon de l'agriculture sa campagne de <strong>crowdfunding</strong> afin de continuer &agrave; am&eacute;liorer son application d'ores et d&eacute;j&agrave; internationale.</span></p>
<p style="text-align: justify;"><span style="font-family: arial,helvetica,sans-serif;"><span style="color: #55575d;"><span style="font-size: small;">Cette campagne ne s'adresse pas aux seuls agriculteurs mais <strong>&agrave; l'ensemble de&nbsp;la population</strong>. Chaque citoyen&nbsp;<strong>est concern&eacute;</strong> et peut <strong>soutenir la d&eacute;marche ShaYoFae</strong> en faisant un don.</span></span>

	<a href="https://www.kisskissbankbank.com/fr/projects/shayofae-share-your-farming-experience" target="_blank" rel="noreferrer">LIEN DE LA CAMPAGNE DE FINANCEMENT</a>
</span></p>
<p style="text-align: justify;"><span style="font-family: arial,helvetica,sans-serif;">La campagne a aussi pour but de <strong>favoriser le reboisement des for&ecirc;ts d&eacute;grad&eacute;es</strong> (
	<a href="https://www.kisskissbankbank.com/fr/projects/shayofae-share-your-farming-experience" target="_blank" rel="noreferrer">en savoir plus</a>
	) en proposant une contrepartie sous forme d'une action de plantation d'arbres.</span></p>
<p style="text-align: justify;"><span style="font-family: arial,helvetica,sans-serif;"><strong><u>Une application avec une version gratuite&nbsp; (
	<a href="https://play.google.com/store/apps/details?id=com.betadigitis.ShayofaeLite" target="_blank" rel="noreferrer">lien de t&eacute;l&eacute;chargement</a>
	) :</u></strong></span></p>
<p style="text-align: justify;">&nbsp;</p>
<p style="text-align: center;"><span style="font-family: arial,helvetica,sans-serif;"><span style="font-size: 14px;">
	<a href="https://play.google.com/store/apps/details?id=com.betadigitis.ShayofaeLite" target="_blank" rel="noreferrer">
		<img src="https://app.algolinked.com/api/multimedia/download/image/5e3ee90b2ec553553b420e7b" width="600" height="196" /></a>
</span></span></p>
<h3 style="color: #55575d; font-family: Arial, sans-serif; font-size: 14px; letter-spacing: normal;">&nbsp;</h3>
<p style="text-align: center;">
	<a href="https://play.google.com/store/apps/details?id=com.betadigitis.ShayofaeLite" target="_blank" rel="noreferrer">
		<img src="https://app.algolinked.com/api/multimedia/download/image/5e3ee8522ec553553b420a9e" width="345" height="345" /></a>
	</p>
<h3 style="color: #55575d; font-family: Arial, sans-serif; font-size: 14px; letter-spacing: normal;">&nbsp;</h3>
<p style="text-align: center;"><span style="font-family: arial,helvetica,sans-serif;">
	<a href="https://play.google.com/store/apps/details?id=com.betadigitis.ShayofaeLite" target="_blank" rel="noreferrer">
		<img src="https://app.algolinked.com/api/multimedia/download/image/5e3ee8882ec553553b420bb8" width="278" height="278" /></a>
		<a href="https://play.google.com/store/apps/details?id=com.betadigitis.ShayofaeLite" target="_blank" rel="noreferrer">
			<img src="https://app.algolinked.com/api/multimedia/download/image/5e3ee89d2ec553553b420c02" width="278" height="278" /></a>
		</span></p>
<p style="text-align: center;"><span style="font-family: arial,helvetica,sans-serif;"><span style="font-size: 16px;">Informations compl&eacute;mentaires :
	<a href="http://www.shayofae.com" target="_blank" rel="noreferrer">http://www.shayofae.com</a>
</span></span></p>
</div>

<div style="font-family: Arial, sans-serif; font-size: 14px; letter-spacing: normal; line-height: 24px; text-align: left; color: #ffffff;background: #45C2D3;">
<br>
<p style="margin-left:1em; "><u><strong><span style="margin-left:1em; font-family: Verdana,Helvetica,Arial,sans-serif;">A propos de ShaYoFae by Betadigitis :</span></strong></u></p>
	<div style="margin-left:2em; margin-right:1em;">
		<p style="text-align: justify;"><span style="font-family: arial,helvetica,sans-serif;"><strong>ShaYoFae</strong>&nbsp;est une application mobile qui aide les agriculteurs &agrave; enrichir&nbsp;<strong>savoirs et savoir faire</strong>&nbsp;par le&nbsp;<strong>partage</strong>&nbsp;et la&nbsp;<strong>comparaison</strong>&nbsp;de leurs pratiques agricoles.</span></p>
		<p style="text-align: justify;"><span style="font-family: arial,helvetica,sans-serif;">L'application&nbsp;lanc&eacute;e&nbsp;d&eacute;but 2019&nbsp;et d&eacute;j&agrave; t&eacute;l&eacute;charg&eacute;e plus de 60 000 fois, v&eacute;ritable&nbsp;<strong>r&eacute;seau social technique</strong>, tisse&nbsp;des communaut&eacute;s d'&eacute;change et de formation&nbsp;et fait&nbsp;<strong>rayonner les savoirs</strong>&nbsp;des agriculteurs participants pour le progr&egrave;s g&eacute;n&eacute;ral de l'agriculture.</span></p>
		<p style="text-align: justify;"><span style="font-family: arial,helvetica,sans-serif;">La startup&nbsp;derri&egrave;re l'application s'appelle Betadigitis. Elle a &eacute;t&eacute; cr&eacute;&eacute;e en 2018 par Herv&eacute; Escriou,&nbsp;<strong>ing&eacute;nieur agronome qui combine&nbsp;ainsi</strong>&nbsp;son exp&eacute;rience&nbsp;<strong>confirm&eacute;e</strong>&nbsp;en agriculture,&nbsp;ses savoirs, sa passion pour le&nbsp;<strong>num&eacute;rique</strong>&nbsp;et une vision du d&eacute;veloppement de l'agriculture. Herv&eacute; Escriou s'est associ&eacute; &agrave;&nbsp;u<strong>n expert en science et technologies logicielles</strong>&nbsp;passionn&eacute; par l'imagination et la cr&eacute;ation d'architectures informatiques, l'analyse des donn&eacute;es, la formation et le conseil.</span></p>
		<p style="text-align: justify;"><span style="font-family: arial,helvetica,sans-serif;">Betadigitis est une startup incub&eacute;e &agrave; Incub'Innov l'incubateur de BondInnov soutenu par l'IRD</span></p>
		<p style="text-align: justify;"><span style="font-family: arial,helvetica,sans-serif;">Betadigitis SAS -&nbsp;11 rue Carnot -&nbsp;94270 LE KREMLIN BICETRE</span></p>
		<p style="margin: 10px 0;">&nbsp;</p>
		<p style="margin: 10px 0;"><strong><u><span style="font-family: Verdana,Helvetica,Arial,sans-serif;">Contact Presse :</span></u></strong></p>
		<p style="margin: 10px 0;"><span style="font-family: Verdana,Helvetica,Arial,sans-serif;">Herv&eacute; Escriou</span></p>
		<p style="margin: 10px 0;"><span style="font-family: Verdana,Helvetica,Arial,sans-serif;">herve.escriou@betadigitis.com</span></p>
    <br>
<p style="text-decoration: none; background: #45C2D3; color: #ffffff; font-family: Verdana, Helvetica, Arial, sans-serif; font-size: 14px; font-weight: normal; line-height: 120%; text-transform: none; margin: 0px;"><strong><span style="font-family: Verdana,Helvetica,Arial,sans-serif;">
			<a style="color: #ffffff;" href="https://app.algolinked.com/room/ShaYoFae%20by%20Betadigitis" target="_blank" rel="noreferrer">Voir l'espace presse ShaYoFae by Betadigitis</a>
		</span></strong></p><br>
	</div></div>

</v-container>
</template>

<script>
	export default {
		data() {
    return {
      icons: [
        'fab fa-facebook',
        'fab fa-twitter',
        'fab fa-linkedin'
      ],
shayofaePressReleaseHtml: `
			        <div style="font-family: Arial, sans-serif; font-size: 14px; line-height: 22px; color: #55575d;">

			          <h2>📰 Communiqué de presse</h2>
											          <hr/><br/>
			          <h3>
			            Shayofae lance un assistant IA pour le choix des variétés
			            de betterave sucrière en France
			          </h3>

			          <p><em>Paris, 30/12/2025</em></p>

			          <p>
			            <strong>Shayofae</strong>, startup AgTech française, annonce le lancement
			            de son <strong>assistant intelligent dédié au choix des variétés
			            de betterave sucrière pour les agriculteurs français</strong>.
			          </p>

			          <p>
			            Basé sur l’<strong>intelligence artificielle</strong>, cet assistant
			            analyse les données agronomiques françaises de référence
			            croisées avec les caractéristiques propres à chaque parcelle.
			          </p>

			          <ul>
			            <li>contexte pédoclimatique local,</li>
			            <li>pressions sanitaires (rhizomanie, cercosporiose, nématodes…),</li>
			            <li>informations disponibles de performances pluriannuelles en France, en Belgique et en Allemagne,</li>
									<li>les<strong> informations partagées par les utilisateurs dans ShaYoFae</strong>.</li>
			          </ul>
								<br/>
			          <p>
			            👉 Le résultat : une <strong>sélection argumentée de variétés
			            de betterave sucrière</strong>, stable, robuste et adaptée
			            aux conditions françaises.
			          </p>

			          <p>
			            L’outil est accessible via une interface simple,
			            <strong>y compris par assistant vocal</strong>,
			            afin de faciliter son usage sur le terrain.
			          </p>

			          <p style="margin-top: 15px;">
			            <strong>
			              Shayofae met l’IA au service de la filière betterave sucrière
			              française pour sécuriser les décisions agronomiques.
			            </strong>
			          </p>
								<p style="margin-top: 15px;">
			             <a href="https://www.shayofae.com/media/ShaYoFae-tuto_Choix_variete.pdf"
			                target="_blank"
			                style="color:#2a7f62; font-weight:bold; text-decoration:none;">
			               📄 Télécharger le tutorial en PDF
			             </a>
			           </p>

			        </div>
			      `
,
      shayofaeTutorialPitchHtml: `
			<br/>
			<br/>
			<div style="font-family: Arial, sans-serif; font-size: 14px; letter-spacing: normal; line-height: 24px; text-align: left; color: #55575d;">
					<p style="margin: 10px 0;"><span style="font-family: Verdana,Helvetica,Arial,sans-serif;">Nouveaut&eacute; 30/12/2025</span></p>
			<br/>
			        <div style="font-family: Arial, sans-serif; font-size: 14px; line-height: 22px; color: #55575d;">

			          <hr/>

			          <h3 style="margin-top: 20px;">🎥 Pitch d’introduction – Tutoriel Shayofae</h3>

			          <blockquote style="margin: 15px 0; padding-left: 15px; border-left: 3px solid #8bbf3d;">
			            <strong>« Choisir la bonne variété de betterave n’a jamais été aussi simple. »</strong>
			          </blockquote>

			          <p>
			            Avec <strong>Shayofae</strong>, vous disposez d’un
			            <strong>assistant agronomique intelligent</strong>, conçu pour vous aider à choisir les variétés
			            de betterave sucrière <strong>les plus adaptées à vos parcelles</strong>, en tenant compte de
			            <strong>vos sols, de vos risques sanitaires et de vos objectifs de production</strong>.
			          </p>

			          <p>
			            En quelques questions simples — à l’écran ou à la voix — Shayofae analyse :
			          </p>

			          <ul>
			            <li>votre <strong>contexte pédoclimatique</strong>,</li>
			            <li>les <strong>maladies présentes</strong> (rhizomanie, cercosporiose, nématodes…),</li>
			            <li>et les <strong>résultats des essais officiels réalisés en France, en Belgique et en Allemagne</strong>,</li>
									<li>les<strong> informations partagées par les utilisateurs dans ShaYoFae</strong>.</li>
			          </ul>

			          <p>
			            👉 Le résultat :
			            <strong>une sélection claire de variétés recommandées</strong>,
			            argumentée, neutre et adaptée à votre situation réelle.
			          </p>

			          <p style="margin-top: 15px;">
			            <strong>
			              Shayofae, c’est l’IA au service de décisions agronomiques simples,
			              fiables et utiles sur le terrain.
			            </strong>
			          </p>

			          <hr/>
								<p style="margin-top: 15px;">
			             <a href="https://www.shayofae.com/media/ShaYoFae-tuto_Choix_variete.pdf"
			                target="_blank"
			                style="color:#2a7f62; font-weight:bold; text-decoration:none;">
			               📄 Télécharger le tutorial en PDF
			             </a>
			           </p>


			        </div>
			      `

    }
  }
}
</script>

<style lang="css" scoped>
</style>
